/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const orderTypeNameSchema = z
  .enum(['EDUSubscription', 'OrgRegistration', 'OrgSubscription', 'OrgUserExtention'])
  .describe('Member names of OrderType.')
